import { get, post, deleteFun, put } from '@/utils/request.js';

/**
 * 左侧菜单列表
 */
export function getMenuList(params) {
    return get('/mpp/menu/findLeftMenus', params);
}

/**
 * 应用信息
 */
export function getSysInfo(params) {
    return get('/mpp/utils/getSysInfo ', params);
}